import React from "react";
import { Link, useParams } from "react-router-dom";
import { useGetDestinationBySlugQuery } from "../../redux/API/DestinationApi";
import Navbar from "../components/partial/Navbar";
import Footer from "../components/partial/Footer";
import { destinationImgUrl, ImgUrl, packageImgUrl } from "../../constant";
import PackageCard from "../components/card/PackageCard";
import { useReferencePackageBySlugQuery } from "../../redux/API/ReferenceApi";
import { referencePackageImgUrl } from "../../admin/Constant";
import EnquiryForm from "../components/form/Enquiryform";

const DestinationDetail = () => {
  const { slug } = useParams();
  const { data: destination } = useGetDestinationBySlugQuery(slug);
  const { data: referenceData } = useReferencePackageBySlugQuery(slug);

  console.log(referenceData, "refdatta")
  console.log("Printing this this this ",referenceData )
  console.log("Printing this this this ",referenceData?.package )
  const filteredPackages = referenceData?.package
  
  return (
    <>
      <Navbar />
      <div className="hero_banner">
        {destination?.destination && (
          <div className="destination-detail h-100">
            <img
              src={`${ImgUrl}${destinationImgUrl}${destination?.destination?.image}`}
              alt={destination?.destination?.name}
              className="w-100 h-100 object-fit-cover"
            />
          </div>
        )}
      </div>
      <div className="container mt-5">
        <div className="row gy-3">
          <div className="col-lg-9">
            <h1>{destination?.destination?.name}</h1>
            <p>{destination?.destination?.description}</p>
          </div>
          <div className="col-lg-3">
            <EnquiryForm
              pid={destination?.destination?._id}
            />
          </div>

          <div className="col-lg-4">
            <div className="row gy-3">
              {referenceData?.recommendePackages?.length > 0 && <h4>Recommended Packages</h4>}
              {referenceData?.recommendePackages?.map((packageItem) => (
                <div key={packageItem._id} className="col-12">
                  <Link
                    to={`/packages/detail/${packageItem?.slug}`}
                    className="text-decoration-none text-unset"
                  >
                    <PackageCard
                      title={packageItem?.name}
                      location={packageItem?.location}
                      price={packageItem?.price}
                      img={`${ImgUrl}${packageImgUrl}${packageItem.destinationId?.images}`}
                      alt="Package Image"
                      days={`${packageItem?.days} Days`}
                    />
                  </Link>
                </div>
              ))}
            </div>
          </div>

          {/* Related Packages Section */}
          <div className="col-12">
            <div className="row gy-3">
              <h4>Related Packages</h4>

              {filteredPackages?.length === 0 && <p>No related packages found.</p>}

              {Array.isArray(filteredPackages) && filteredPackages?.map((packageItem) => (
                <div key={packageItem._id} className="col-lg-4">
                  <Link
                    to={`/relatedpackage/${packageItem?.slug}`}
                    className="text-decoration-none text-unset"
                  >
                    <PackageCard
                      location={packageItem?.name}
                      days={packageItem?.days}
                      price={packageItem?.price}
                      img={`${ImgUrl}${referencePackageImgUrl}${packageItem?.image}`}
                      alt="Package Image"
                    />
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};


export default DestinationDetail;
